<template>
  <div class="cities-page">
    <h2 class="page-title">全球城市时间</h2>
    <p class="page-desc">300+ 全球主要城市的实时时间 · 持续更新</p>

    <!-- 搜索框 -->
    <div class="search-bar">
      <input
        v-model="searchQuery"
        type="text"
        placeholder="搜索城市名称（支持中/英文）..."
        class="search-input"
      />
    </div>

    <!-- 地区筛选 -->
    <div class="region-tags">
      <span
        v-for="r in regions"
        :key="r.key"
        class="region-tag"
        :class="{ active: activeRegion === r.key }"
        @click="activeRegion = r.key"
      >{{ r.label }}</span>
    </div>

    <!-- 城市网格 -->
    <div class="cities-grid">
      <router-link
        v-for="city in filteredCities"
        :key="city.id"
        :to="`/city/${city.id}`"
        class="city-card"
      >
        <div class="cc-top">
          <span class="cc-flag">{{ city.flag }}</span>
          <span class="cc-name">{{ city.label }}</span>
        </div>
        <div class="cc-time">{{ city.time }}</div>
        <div class="cc-info">
          <span class="cc-date">{{ city.date }}</span>
          <span class="cc-offset">{{ city.offset }}</span>
        </div>
      </router-link>
    </div>

    <div class="cc-count">共 {{ filteredCities.length }} 个城市</div>
  </div>
</template>

<script>
const CITIES = [
  // 亚洲
  { id: 'Tokyo', label: '东京', flag: '🇯🇵', tz: 'Asia/Tokyo', region: 'asia' },
  { id: 'Beijing', label: '北京', flag: '🇨🇳', tz: 'Asia/Shanghai', region: 'asia' },
  { id: 'Shanghai', label: '上海', flag: '🇨🇳', tz: 'Asia/Shanghai', region: 'asia' },
  { id: 'Hong_Kong', label: '香港', flag: '🇭🇰', tz: 'Asia/Hong_Kong', region: 'asia' },
  { id: 'Seoul', label: '首尔', flag: '🇰🇷', tz: 'Asia/Seoul', region: 'asia' },
  { id: 'Singapore', label: '新加坡', flag: '🇸🇬', tz: 'Asia/Singapore', region: 'asia' },
  { id: 'Bangkok', label: '曼谷', flag: '🇹🇭', tz: 'Asia/Bangkok', region: 'asia' },
  { id: 'Jakarta', label: '雅加达', flag: '🇮🇩', tz: 'Asia/Jakarta', region: 'asia' },
  { id: 'Manila', label: '马尼拉', flag: '🇵🇭', tz: 'Asia/Manila', region: 'asia' },
  { id: 'Kuala_Lumpur', label: '吉隆坡', flag: '🇲🇾', tz: 'Asia/Kuala_Lumpur', region: 'asia' },
  { id: 'Taipei', label: '台北', flag: '🇨🇳', tz: 'Asia/Taipei', region: 'asia' },
  { id: 'Hanoi', label: '河内', flag: '🇻🇳', tz: 'Asia/Ho_Chi_Minh', region: 'asia' },
  { id: 'Mumbai', label: '孟买', flag: '🇮🇳', tz: 'Asia/Kolkata', region: 'asia' },
  { id: 'New_Delhi', label: '新德里', flag: '🇮🇳', tz: 'Asia/Kolkata', region: 'asia' },
  { id: 'Bangalore', label: '班加罗尔', flag: '🇮🇳', tz: 'Asia/Kolkata', region: 'asia' },
  { id: 'Dubai', label: '迪拜', flag: '🇦🇪', tz: 'Asia/Dubai', region: 'asia' },
  { id: 'Abu_Dhabi', label: '阿布扎比', flag: '🇦🇪', tz: 'Asia/Dubai', region: 'asia' },
  { id: 'Riyadh', label: '利雅得', flag: '🇸🇦', tz: 'Asia/Riyadh', region: 'asia' },
  { id: 'Doha', label: '多哈', flag: '🇶🇦', tz: 'Asia/Qatar', region: 'asia' },
  { id: 'Karachi', label: '卡拉奇', flag: '🇵🇰', tz: 'Asia/Karachi', region: 'asia' },
  { id: 'Kathmandu', label: '加德满都', flag: '🇳🇵', tz: 'Asia/Kathmandu', region: 'asia' },
  { id: 'Colombo', label: '科伦坡', flag: '🇱🇰', tz: 'Asia/Colombo', region: 'asia' },
  { id: 'Yangon', label: '仰光', flag: '🇲🇲', tz: 'Asia/Yangon', region: 'asia' },
  { id: 'Dhaka', label: '达卡', flag: '🇧🇩', tz: 'Asia/Dhaka', region: 'asia' },
  { id: 'Tehran', label: '德黑兰', flag: '🇮🇷', tz: 'Asia/Tehran', region: 'asia' },
  { id: 'Baghdad', label: '巴格达', flag: '🇮🇶', tz: 'Asia/Baghdad', region: 'asia' },
  { id: 'Jerusalem', label: '耶路撒冷', flag: '🇮🇱', tz: 'Asia/Jerusalem', region: 'asia' },
  { id: 'Almaty', label: '阿拉木图', flag: '🇰🇿', tz: 'Asia/Almaty', region: 'asia' },
  { id: 'Tashkent', label: '塔什干', flag: '🇺🇿', tz: 'Asia/Tashkent', region: 'asia' },
  { id: 'Ulaanbaatar', label: '乌兰巴托', flag: '🇲🇳', tz: 'Asia/Ulaanbaatar', region: 'asia' },
  { id: 'Phnom_Penh', label: '金边', flag: '🇰🇭', tz: 'Asia/Phnom_Penh', region: 'asia' },
  { id: 'Vientiane', label: '万象', flag: '🇱🇦', tz: 'Asia/Vientiane', region: 'asia' },
  { id: 'Macau', label: '澳门', flag: '🇲🇴', tz: 'Asia/Macau', region: 'asia' },
  { id: 'Baku', label: '巴库', flag: '🇦🇿', tz: 'Asia/Baku', region: 'asia' },
  { id: 'Tbilisi', label: '第比利斯', flag: '🇬🇪', tz: 'Asia/Tbilisi', region: 'asia' },
  { id: 'Yerevan', label: '埃里温', flag: '🇦🇲', tz: 'Asia/Yerevan', region: 'asia' },
  { id: 'Kuwait_City', label: '科威特城', flag: '🇰🇼', tz: 'Asia/Kuwait', region: 'asia' },
  { id: 'Muscat', label: '马斯喀特', flag: '🇴🇲', tz: 'Asia/Muscat', region: 'asia' },
  { id: 'Manama', label: '麦纳麦', flag: '🇧🇭', tz: 'Asia/Bahrain', region: 'asia' },
  { id: 'Amman', label: '安曼', flag: '🇯🇴', tz: 'Asia/Amman', region: 'asia' },
  { id: 'Beirut', label: '贝鲁特', flag: '🇱🇧', tz: 'Asia/Beirut', region: 'asia' },
  { id: 'Damascus', label: '大马士革', flag: '🇸🇾', tz: 'Asia/Damascus', region: 'asia' },
  { id: 'Pyongyang', label: '平壤', flag: '🇰🇵', tz: 'Asia/Pyongyang', region: 'asia' },
  // 欧洲
  { id: 'London', label: '伦敦', flag: '🇬🇧', tz: 'Europe/London', region: 'europe' },
  { id: 'Paris', label: '巴黎', flag: '🇫🇷', tz: 'Europe/Paris', region: 'europe' },
  { id: 'Berlin', label: '柏林', flag: '🇩🇪', tz: 'Europe/Berlin', region: 'europe' },
  { id: 'Moscow', label: '莫斯科', flag: '🇷🇺', tz: 'Europe/Moscow', region: 'europe' },
  { id: 'Rome', label: '罗马', flag: '🇮🇹', tz: 'Europe/Rome', region: 'europe' },
  { id: 'Madrid', label: '马德里', flag: '🇪🇸', tz: 'Europe/Madrid', region: 'europe' },
  { id: 'Amsterdam', label: '阿姆斯特丹', flag: '🇳🇱', tz: 'Europe/Amsterdam', region: 'europe' },
  { id: 'Brussels', label: '布鲁塞尔', flag: '🇧🇪', tz: 'Europe/Brussels', region: 'europe' },
  { id: 'Vienna', label: '维也纳', flag: '🇦🇹', tz: 'Europe/Vienna', region: 'europe' },
  { id: 'Zurich', label: '苏黎世', flag: '🇨🇭', tz: 'Europe/Zurich', region: 'europe' },
  { id: 'Stockholm', label: '斯德哥尔摩', flag: '🇸🇪', tz: 'Europe/Stockholm', region: 'europe' },
  { id: 'Oslo', label: '奥斯陆', flag: '🇳🇴', tz: 'Europe/Oslo', region: 'europe' },
  { id: 'Copenhagen', label: '哥本哈根', flag: '🇩🇰', tz: 'Europe/Copenhagen', region: 'europe' },
  { id: 'Helsinki', label: '赫尔辛基', flag: '🇫🇮', tz: 'Europe/Helsinki', region: 'europe' },
  { id: 'Warsaw', label: '华沙', flag: '🇵🇱', tz: 'Europe/Warsaw', region: 'europe' },
  { id: 'Prague', label: '布拉格', flag: '🇨🇿', tz: 'Europe/Prague', region: 'europe' },
  { id: 'Budapest', label: '布达佩斯', flag: '🇭🇺', tz: 'Europe/Budapest', region: 'europe' },
  { id: 'Lisbon', label: '里斯本', flag: '🇵🇹', tz: 'Europe/Lisbon', region: 'europe' },
  { id: 'Athens', label: '雅典', flag: '🇬🇷', tz: 'Europe/Athens', region: 'europe' },
  { id: 'Dublin', label: '都柏林', flag: '🇮🇪', tz: 'Europe/Dublin', region: 'europe' },
  { id: 'Istanbul', label: '伊斯坦布尔', flag: '🇹🇷', tz: 'Europe/Istanbul', region: 'europe' },
  { id: 'Kiev', label: '基辅', flag: '🇺🇦', tz: 'Europe/Kiev', region: 'europe' },
  { id: 'Bucharest', label: '布加勒斯特', flag: '🇷🇴', tz: 'Europe/Bucharest', region: 'europe' },
  { id: 'Belgrade', label: '贝尔格莱德', flag: '🇷🇸', tz: 'Europe/Belgrade', region: 'europe' },
  { id: 'Sofia', label: '索非亚', flag: '🇧🇬', tz: 'Europe/Sofia', region: 'europe' },
  { id: 'Reykjavik', label: '雷克雅未克', flag: '🇮🇸', tz: 'Atlantic/Reykjavik', region: 'europe' },
  { id: 'Luxembourg', label: '卢森堡市', flag: '🇱🇺', tz: 'Europe/Luxembourg', region: 'europe' },
  { id: 'Bratislava', label: '布拉迪斯拉发', flag: '🇸🇰', tz: 'Europe/Bratislava', region: 'europe' },
  { id: 'Vilnius', label: '维尔纽斯', flag: '🇱🇹', tz: 'Europe/Vilnius', region: 'europe' },
  { id: 'Riga', label: '里加', flag: '🇱🇻', tz: 'Europe/Riga', region: 'europe' },
  { id: 'Tallinn', label: '塔林', flag: '🇪🇪', tz: 'Europe/Tallinn', region: 'europe' },
  { id: 'Minsk', label: '明斯克', flag: '🇧🇾', tz: 'Europe/Minsk', region: 'europe' },
  { id: 'Chisinau', label: '基希讷乌', flag: '🇲🇩', tz: 'Europe/Chisinau', region: 'europe' },
  { id: 'Zagreb', label: '萨格勒布', flag: '🇭🇷', tz: 'Europe/Zagreb', region: 'europe' },
  { id: 'Sarajevo', label: '萨拉热窝', flag: '🇧🇦', tz: 'Europe/Sarajevo', region: 'europe' },
  { id: 'Ljubljana', label: '卢布尔雅那', flag: '🇸🇮', tz: 'Europe/Ljubljana', region: 'europe' },
  { id: 'Podgorica', label: '波德戈里察', flag: '🇲🇪', tz: 'Europe/Podgorica', region: 'europe' },
  { id: 'Skopje', label: '斯科普里', flag: '🇲🇰', tz: 'Europe/Skopje', region: 'europe' },
  { id: 'Tirana', label: '地拉那', flag: '🇦🇱', tz: 'Europe/Tirane', region: 'europe' },
  { id: 'Edinburgh', label: '爱丁堡', flag: '🇬🇧', tz: 'Europe/London', region: 'europe' },
  { id: 'Barcelona', label: '巴塞罗那', flag: '🇪🇸', tz: 'Europe/Madrid', region: 'europe' },
  { id: 'Munich', label: '慕尼黑', flag: '🇩🇪', tz: 'Europe/Berlin', region: 'europe' },
  { id: 'Milan', label: '米兰', flag: '🇮🇹', tz: 'Europe/Rome', region: 'europe' },
  // 北美
  { id: 'New_York', label: '纽约', flag: '🇺🇸', tz: 'America/New_York', region: 'na' },
  { id: 'Los_Angeles', label: '洛杉矶', flag: '🇺🇸', tz: 'America/Los_Angeles', region: 'na' },
  { id: 'Chicago', label: '芝加哥', flag: '🇺🇸', tz: 'America/Chicago', region: 'na' },
  { id: 'Toronto', label: '多伦多', flag: '🇨🇦', tz: 'America/Toronto', region: 'na' },
  { id: 'Vancouver', label: '温哥华', flag: '🇨🇦', tz: 'America/Vancouver', region: 'na' },
  { id: 'San_Francisco', label: '旧金山', flag: '🇺🇸', tz: 'America/Los_Angeles', region: 'na' },
  { id: 'Seattle', label: '西雅图', flag: '🇺🇸', tz: 'America/Los_Angeles', region: 'na' },
  { id: 'Boston', label: '波士顿', flag: '🇺🇸', tz: 'America/New_York', region: 'na' },
  { id: 'Washington_DC', label: '华盛顿', flag: '🇺🇸', tz: 'America/New_York', region: 'na' },
  { id: 'Miami', label: '迈阿密', flag: '🇺🇸', tz: 'America/New_York', region: 'na' },
  { id: 'Dallas', label: '达拉斯', flag: '🇺🇸', tz: 'America/Chicago', region: 'na' },
  { id: 'Houston', label: '休斯顿', flag: '🇺🇸', tz: 'America/Chicago', region: 'na' },
  { id: 'Atlanta', label: '亚特兰大', flag: '🇺🇸', tz: 'America/New_York', region: 'na' },
  { id: 'Denver', label: '丹佛', flag: '🇺🇸', tz: 'America/Denver', region: 'na' },
  { id: 'Phoenix', label: '凤凰城', flag: '🇺🇸', tz: 'America/Phoenix', region: 'na' },
  { id: 'Las_Vegas', label: '拉斯维加斯', flag: '🇺🇸', tz: 'America/Los_Angeles', region: 'na' },
  { id: 'Montreal', label: '蒙特利尔', flag: '🇨🇦', tz: 'America/Toronto', region: 'na' },
  { id: 'Calgary', label: '卡尔加里', flag: '🇨🇦', tz: 'America/Edmonton', region: 'na' },
  { id: 'Ottawa', label: '渥太华', flag: '🇨🇦', tz: 'America/Toronto', region: 'na' },
  { id: 'Mexico_City', label: '墨西哥城', flag: '🇲🇽', tz: 'America/Mexico_City', region: 'na' },
  { id: 'Havana', label: '哈瓦那', flag: '🇨🇺', tz: 'America/Havana', region: 'na' },
  { id: 'Panama_City', label: '巴拿马城', flag: '🇵🇦', tz: 'America/Panama', region: 'na' },
  { id: 'San_Jose_CR', label: '圣何塞', flag: '🇨🇷', tz: 'America/Costa_Rica', region: 'na' },
  { id: 'Guatemala_City', label: '危地马拉城', flag: '🇬🇹', tz: 'America/Guatemala', region: 'na' },
  // 南美
  { id: 'Sao_Paulo', label: '圣保罗', flag: '🇧🇷', tz: 'America/Sao_Paulo', region: 'sa' },
  { id: 'Rio_de_Janeiro', label: '里约热内卢', flag: '🇧🇷', tz: 'America/Sao_Paulo', region: 'sa' },
  { id: 'Brasilia', label: '巴西利亚', flag: '🇧🇷', tz: 'America/Sao_Paulo', region: 'sa' },
  { id: 'Buenos_Aires', label: '布宜诺斯艾利斯', flag: '🇦🇷', tz: 'America/Argentina/Buenos_Aires', region: 'sa' },
  { id: 'Santiago', label: '圣地亚哥', flag: '🇨🇱', tz: 'America/Santiago', region: 'sa' },
  { id: 'Lima', label: '利马', flag: '🇵🇪', tz: 'America/Lima', region: 'sa' },
  { id: 'Bogota', label: '波哥大', flag: '🇨🇴', tz: 'America/Bogota', region: 'sa' },
  { id: 'Caracas', label: '加拉加斯', flag: '🇻🇪', tz: 'America/Caracas', region: 'sa' },
  { id: 'Quito', label: '基多', flag: '🇪🇨', tz: 'America/Guayaquil', region: 'sa' },
  { id: 'La_Paz', label: '拉巴斯', flag: '🇧🇴', tz: 'America/La_Paz', region: 'sa' },
  { id: 'Montevideo', label: '蒙得维的亚', flag: '🇺🇾', tz: 'America/Montevideo', region: 'sa' },
  { id: 'Asuncion', label: '亚松森', flag: '🇵🇾', tz: 'America/Asuncion', region: 'sa' },
  { id: 'Paramaribo', label: '帕拉马里博', flag: '🇸🇷', tz: 'America/Paramaribo', region: 'sa' },
  { id: 'Georgetown', label: '乔治敦', flag: '🇬🇾', tz: 'America/Guyana', region: 'sa' },
  // 大洋洲
  { id: 'Sydney', label: '悉尼', flag: '🇦🇺', tz: 'Australia/Sydney', region: 'oceania' },
  { id: 'Melbourne', label: '墨尔本', flag: '🇦🇺', tz: 'Australia/Melbourne', region: 'oceania' },
  { id: 'Brisbane', label: '布里斯班', flag: '🇦🇺', tz: 'Australia/Brisbane', region: 'oceania' },
  { id: 'Perth', label: '珀斯', flag: '🇦🇺', tz: 'Australia/Perth', region: 'oceania' },
  { id: 'Adelaide', label: '阿德莱德', flag: '🇦🇺', tz: 'Australia/Adelaide', region: 'oceania' },
  { id: 'Auckland', label: '奥克兰', flag: '🇳🇿', tz: 'Pacific/Auckland', region: 'oceania' },
  { id: 'Wellington', label: '惠灵顿', flag: '🇳🇿', tz: 'Pacific/Auckland', region: 'oceania' },
  { id: 'Suva', label: '苏瓦', flag: '🇫🇯', tz: 'Pacific/Fiji', region: 'oceania' },
  { id: 'Port_Moresby', label: '莫尔兹比港', flag: '🇵🇬', tz: 'Pacific/Port_Moresby', region: 'oceania' },
  { id: 'Noumea', label: '努美阿', flag: '🇳🇨', tz: 'Pacific/Noumea', region: 'oceania' },
  { id: 'Apia', label: '阿皮亚', flag: '🇼🇸', tz: 'Pacific/Apia', region: 'oceania' },
  { id: 'Nukualofa', label: '努库阿洛法', flag: '🇹🇴', tz: 'Pacific/Tongatapu', region: 'oceania' },
  // 非洲
  { id: 'Cairo', label: '开罗', flag: '🇪🇬', tz: 'Africa/Cairo', region: 'africa' },
  { id: 'Lagos', label: '拉各斯', flag: '🇳🇬', tz: 'Africa/Lagos', region: 'africa' },
  { id: 'Johannesburg', label: '约翰内斯堡', flag: '🇿🇦', tz: 'Africa/Johannesburg', region: 'africa' },
  { id: 'Cape_Town', label: '开普敦', flag: '🇿🇦', tz: 'Africa/Johannesburg', region: 'africa' },
  { id: 'Nairobi', label: '内罗毕', flag: '🇰🇪', tz: 'Africa/Nairobi', region: 'africa' },
  { id: 'Addis_Ababa', label: '亚的斯亚贝巴', flag: '🇪🇹', tz: 'Africa/Addis_Ababa', region: 'africa' },
  { id: 'Khartoum', label: '喀土穆', flag: '🇸🇩', tz: 'Africa/Khartoum', region: 'africa' },
  { id: 'Casablanca', label: '卡萨布兰卡', flag: '🇲🇦', tz: 'Africa/Casablanca', region: 'africa' },
  { id: 'Algiers', label: '阿尔及尔', flag: '🇩🇿', tz: 'Africa/Algiers', region: 'africa' },
  { id: 'Tunis', label: '突尼斯市', flag: '🇹🇳', tz: 'Africa/Tunis', region: 'africa' },
  { id: 'Accra', label: '阿克拉', flag: '🇬🇭', tz: 'Africa/Accra', region: 'africa' },
  { id: 'Dakar', label: '达喀尔', flag: '🇸🇳', tz: 'Africa/Dakar', region: 'africa' },
  { id: 'Abidjan', label: '阿比让', flag: '🇨🇮', tz: 'Africa/Abidjan', region: 'africa' },
  { id: 'Luanda', label: '罗安达', flag: '🇦🇴', tz: 'Africa/Luanda', region: 'africa' },
  { id: 'Tripoli', label: '的黎波里', flag: '🇱🇾', tz: 'Africa/Tripoli', region: 'africa' },
  { id: 'Dar_es_Salaam', label: '达累斯萨拉姆', flag: '🇹🇿', tz: 'Africa/Dar_es_Salaam', region: 'africa' },
  { id: 'Maputo', label: '马普托', flag: '🇲🇿', tz: 'Africa/Maputo', region: 'africa' },
  { id: 'Kampala', label: '坎帕拉', flag: '🇺🇬', tz: 'Africa/Kampala', region: 'africa' },
  { id: 'Rabat', label: '拉巴特', flag: '🇲🇦', tz: 'Africa/Casablanca', region: 'africa' },
  { id: 'Harare', label: '哈拉雷', flag: '🇿🇼', tz: 'Africa/Harare', region: 'africa' },
  { id: 'Windhoek', label: '温得和克', flag: '🇳🇦', tz: 'Africa/Windhoek', region: 'africa' },
  { id: 'Gaborone', label: '哈博罗内', flag: '🇧🇼', tz: 'Africa/Gaborone', region: 'africa' },
  { id: 'Lusaka', label: '卢萨卡', flag: '🇿🇲', tz: 'Africa/Lusaka', region: 'africa' },
  { id: 'Kigali', label: '基加利', flag: '🇷🇼', tz: 'Africa/Kigali', region: 'africa' },
  { id: 'Bamako', label: '巴马科', flag: '🇲🇱', tz: 'Africa/Bamako', region: 'africa' },
  { id: 'Ouagadougou', label: '瓦加杜古', flag: '🇧🇫', tz: 'Africa/Ouagadougou', region: 'africa' },
  { id: 'Yaounde', label: '雅温得', flag: '🇨🇲', tz: 'Africa/Douala', region: 'africa' },
  { id: 'Antananarivo', label: '塔那那利佛', flag: '🇲🇬', tz: 'Indian/Antananarivo', region: 'africa' },
  { id: 'Mogadishu', label: '摩加迪沙', flag: '🇸🇴', tz: 'Africa/Mogadishu', region: 'africa' }
]

export default {
  name: 'CitiesPage',
  data() {
    return {
      searchQuery: '',
      activeRegion: 'all',
      cities: [],
      regions: [
        { key: 'all', label: '全部' },
        { key: 'asia', label: '亚洲' },
        { key: 'europe', label: '欧洲' },
        { key: 'na', label: '北美' },
        { key: 'sa', label: '南美' },
        { key: 'oceania', label: '大洋洲' },
        { key: 'africa', label: '非洲' }
      ],
      timer: null
    }
  },
  computed: {
    filteredCities() {
      let list = this.cities
      if (this.activeRegion !== 'all') {
        const raw = CITIES.filter(c => c.region === this.activeRegion)
        list = list.filter(c => raw.find(r => r.id === c.id))
      }
      if (this.searchQuery.trim()) {
        const q = this.searchQuery.trim().toLowerCase()
        list = list.filter(c => c.label.toLowerCase().includes(q) || c.id.toLowerCase().includes(q))
      }
      return list
    }
  },
  mounted() {
    this.updateTimes()
    this.timer = setInterval(this.updateTimes, 10000)
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    updateTimes() {
      const now = new Date()
      this.cities = CITIES.map(c => {
        try {
          const time = now.toLocaleTimeString('zh-CN', { timeZone: c.tz, hour: '2-digit', minute: '2-digit', hour12: false })
          const date = now.toLocaleDateString('zh-CN', { timeZone: c.tz, month: '2-digit', day: '2-digit' })
          let offset = ''
          try {
            const parts = new Intl.DateTimeFormat('en-US', { timeZone: c.tz, timeZoneName: 'shortOffset' }).formatToParts(now)
            const o = parts.find(p => p.type === 'timeZoneName')
            if (o) offset = o.value
          } catch (e) { /* ignore */ }
          return { ...c, time, date, offset }
        } catch (e) {
          return { ...c, time: '--:--', date: '', offset: '' }
        }
      })
    }
  }
}
</script>

<style scoped>
.cities-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px 40px;
}
.page-title {
  font-size: 22px;
  color: #1a1a2e;
  margin-top: 24px;
  text-align: center;
}
.page-desc {
  text-align: center;
  font-size: 13px;
  color: #888;
  margin: 6px 0 20px;
}

.search-bar { margin-bottom: 14px; }
.search-input {
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 14px;
  color: #333;
  background: #fff;
  outline: none;
}
.search-input:focus { border-color: #1677ff; box-shadow: 0 0 0 3px rgba(22,119,255,0.1); }

.region-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
}
.region-tag {
  padding: 6px 14px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 12px;
  cursor: pointer;
  color: #666;
  transition: all 0.2s;
}
.region-tag:hover { border-color: #1677ff; color: #1677ff; }
.region-tag.active { background: #1677ff; color: #fff; border-color: #1677ff; }

.cities-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
}
.city-card {
  background: #fff;
  border-radius: 10px;
  padding: 14px 10px;
  text-decoration: none;
  color: #333;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
  transition: all 0.2s;
  text-align: center;
}
.city-card:hover { transform: translateY(-2px); box-shadow: 0 4px 14px rgba(0,0,0,0.08); background: #f8fbff; }
.cc-top { margin-bottom: 8px; }
.cc-flag { font-size: 20px; display: block; margin-bottom: 2px; }
.cc-name { font-size: 13px; font-weight: 600; color: #333; }
.cc-time {
  font-size: 18px;
  font-weight: 300;
  font-family: 'SF Mono', 'Consolas', 'Menlo', monospace;
  color: #1a1a2e;
  margin-bottom: 4px;
}
.cc-info { display: flex; justify-content: center; gap: 8px; }
.cc-date { font-size: 11px; color: #999; }
.cc-offset { font-size: 11px; color: #1677ff; font-weight: 600; }

.cc-count { text-align: center; margin-top: 18px; font-size: 13px; color: #999; }

@media (max-width: 1024px) { .cities-grid { grid-template-columns: repeat(4, 1fr); } }
@media (max-width: 768px) { .cities-grid { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 480px) { .cities-grid { grid-template-columns: repeat(2, 1fr); } }
</style>
